import cls from 'classnames';
import React, { FC } from 'react';

import Image from '@/components/image';
import { isVideoAsset } from '@/lib/utils';
import { ImageAsset, MediaAsset } from '@/types/views/generic';

const renderVideo = (src: string, isMobile: boolean) => (
  <video
    autoPlay
    playsInline
    loop
    muted
    src={src}
    className={cls(
      'absolute z-10 inset-0 object-cover h-full w-full',
      isMobile ? 'block md:hidden' : 'hidden md:block',
    )}
  />
);

const renderImage = (asset: ImageAsset, className?: string) => (
  <Image
    src={asset.src}
    fallbackSrc={asset.fallbackSrc}
    objectFit="cover"
    className={className}
    basicLoader={asset.isExternal}
  />
);

interface MediaBackgroundProps {
  background?: MediaAsset;
  backgroundMobile?: MediaAsset;
}

const MediaBackground: FC<MediaBackgroundProps> = ({
  background,
  backgroundMobile,
}) => {
  const desktopBackground = background ?? backgroundMobile;
  const mobileBackground = backgroundMobile ?? background;

  if (!desktopBackground && !mobileBackground) {
    return null;
  }

  const renderBackground = () => {
    if (!desktopBackground) {
      return null;
    }

    return isVideoAsset(desktopBackground)
      ? renderVideo(desktopBackground.src, false)
      : renderImage(desktopBackground, 'hidden md:block');
  };

  const renderMobileBackground = () => {
    if (!mobileBackground) {
      return null;
    }

    return isVideoAsset(mobileBackground)
      ? renderVideo(mobileBackground.src, true)
      : renderImage(
          mobileBackground,
          desktopBackground ? 'block md:hidden' : undefined,
        );
  };

  return (
    <>
      {renderBackground()}

      {renderMobileBackground()}
    </>
  );
};

export default MediaBackground;
